export default __webpack_public_path__ + "static/media/coupon.d4f2b139.svg";